var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.904297 7.59066C0.904297 5.21778 0.904297 4.03134 1.37341 3.12826C1.76872 2.36725 2.38922 1.74675 3.15024 1.35143C4.05331 0.882324 5.23975 0.882324 7.61263 0.882324H14.196C16.5688 0.882324 17.7553 0.882324 18.6584 1.35143C19.4194 1.74675 20.0399 2.36725 20.4352 3.12826C20.9043 4.03134 20.9043 5.21778 20.9043 7.59066V14.174C20.9043 16.5469 20.9043 17.7333 20.4352 18.6364C20.0399 19.3974 19.4194 20.0179 18.6584 20.4132C17.7553 20.8823 16.5688 20.8823 14.196 20.8823H7.61263C5.23975 20.8823 4.05331 20.8823 3.15024 20.4132C2.38922 20.0179 1.76872 19.3974 1.37341 18.6364C0.904297 17.7333 0.904297 16.5469 0.904297 14.174V7.59066Z",
    fill: "url(#paint0_linear_876_2734)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7929 13.6599L15.2373 10.8821H12.5706V8.93766C12.5706 8.15988 12.8484 7.54877 14.0706 7.54877H15.3484V4.99322C14.6262 4.88211 13.8484 4.771 13.1262 4.771C10.8484 4.771 9.2373 6.15989 9.2373 8.65989V10.8821H6.7373V13.6599H9.2373V20.8821C10.3484 20.8821 11.4595 20.8821 12.5706 20.8821V13.6599H14.7929Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_876_2734",
    x1: 10.9043,
    y1: 20.298,
    x2: 10.9043,
    y2: 0.882324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0062E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#19AFFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.6c79cfb79d8f3c83d307ecfec4ead050.svg";
export { ForwardRef as ReactComponent };